import React from 'react';
import { Package, Loader2 } from 'lucide-react';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-purple-100 to-indigo-100 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="relative mb-8">
          {/* Animated background circle */}
          <div className="absolute inset-0 bg-purple-200 rounded-full animate-ping opacity-75"></div>
          
          {/* Icon container */}
          <div className="relative bg-gradient-to-br from-purple-600 to-indigo-600 w-24 h-24 rounded-3xl flex items-center justify-center mx-auto shadow-2xl">
            <Package size={48} className="text-white" strokeWidth={2.5} />
          </div>
        </div>

        <h2 className="text-2xl font-bold text-gray-800 mb-3">
          Packer Portal
        </h2>
        
        <div className="flex items-center justify-center gap-2 text-purple-600">
          <Loader2 size={20} className="animate-spin" />
          <p className="text-sm font-medium">
            Loading your workspace...
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
